/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerfEnergyKpiPeriod } from '../../models/perf-energy-kpi-period';

export interface GetPerfEnergyKpIsPerStation$Params {

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getPerfEnergyKpIsPerStation(http: HttpClient, rootUrl: string, params: GetPerfEnergyKpIsPerStation$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyKpiPeriod>> {
  const rb = new RequestBuilder(rootUrl, getPerfEnergyKpIsPerStation.PATH, 'get');
  if (params) {
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PerfEnergyKpiPeriod>;
    })
  );
}

getPerfEnergyKpIsPerStation.PATH = '/custom/kpi/perf-energy/station/{uid}';
